import React from "react";
export const DarkNumberedCard = ({ index, title, content }) => (React.createElement("div", { className: "dark-numbered-card" },
    React.createElement("h3", { className: "dark-numbered-card__title" },
        React.createElement("span", { className: "dark-numbered-card__index" }, index),
        title),
    React.createElement("p", { className: "dark-numbered-card__content" }, content)));
